import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchApprovers } from "../reducers/workflowsSlice";
import { Select } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import _ from "lodash";

const { Option } = Select;

const ApproverSearch = ({
	roleId,
	organisationId,
	domain,
	value,
	onChange,
}) => {
	const [data, setData] = useState([]);
	const [ignoreOrg, setIgnoreOrg] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		let isMounted = true; //mutable flag
		const fetchData = async () => {
			const response = await dispatch(
				fetchApprovers({
					roleId: ignoreOrg ? null : roleId,
					organisationId: ignoreOrg ? null : organisationId,
					domain,
				})
			).unwrap();
			if (response && response.length && isMounted) {
				const trimmed = response.map((d) => {
					return {
						fullName: d.fullName,
						userId: d.userId,
						jobTitle: d.jobTitle,
					};
				});
				const data = _.uniqWith(trimmed, _.isEqual);
				setData(data); //check mounted flag
			}
		};
		fetchData();
		return () => {
			isMounted = false;
		}; //clean up, mounted untrue
	}, [dispatch, roleId, ignoreOrg, organisationId, domain]);

	const triggerChange = (value) => {
		onChange?.(value);
	};

	const options = data
		.sort((a, b) =>
			a.fullName === b.fullName ? 0 : a.fullName > b.fullName ? 1 : -1
		)
		.map((d) => {
			return (
				<Option key={d.userId} value={d.userId}>
					{`${d.fullName} ${d.jobTitle ? `(${d.jobTitle})` : ""}`}
				</Option>
			);
		});

	return (
		<>
			<Select
				showSearch
				value={value}
				onChange={triggerChange}
				defaultActiveFirstOption={false}
				placeholder="Pick a person from this list"
				filterOption={(input, option) =>
					option.children.toLowerCase().includes(input.toLowerCase())
				}
			>
				{options}
			</Select>
			<Checkbox
				onChange={(e) => setIgnoreOrg(e.target.checked)}
				style={{ marginTop: 10, marginBottom: 20 }}
			>
				Search for Any Approver
			</Checkbox>
			<p style={{ color: "#555" }}>
				You can only change to another person who has the same level of
				access / same role as the original person.
			</p>
			<p style={{ color: "#555" }}>
				If you don't see the person you want here, you will need to
				check that they have the appropriate access levels with support.
				Otherwise, delegate this workflow instead.
			</p>
			<p style={{ color: "#555" }}>
				If you'd like to instead search for anyone regardless of their
				role & team, tick the "Search for Any Approver" option.
			</p>
		</>
	);
};

export default ApproverSearch;
